import React, {useState} from 'react';
import {Grid, Pagination, Stack, Typography} from "@mui/material";
import Divider from "@mui/material/Divider";
import Search from "../../../../components/Admin/Search/Search";
import Loading from "../../../../components/Site/Loading/Loading";
import ITable from "../../../../components/Admin/table/ITable";
import {GetState} from "../../../../redux/reduxhelper";
import {CONFIRM_COUNT} from "../../../../redux/action/type.action";
import {useQuery} from "react-query";
import {getSubscribersList} from "../../../../api/AdminApi";
import {enToFaNum} from "../../../../tools/helper";

const DashboardRegistrants = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const [searchQuery, setSearchQuery] = useState("");



    const confirmCount = GetState(CONFIRM_COUNT, 0)

    // local variables
    const perPage = 10;
    let rowsData = [];
    let pagination = {
        page: 1,
        defaultPage: 1,
        perPage: 10,
        count: 10,
        from: 1,
        to: 10,
        total: 10,
        prev_page_url: null,
        next_page_url: null,
    };


    // dev react query method
    const getRegisterList = async () => {
        try {

            let res = await getSubscribersList(currentPage, perPage, searchQuery)
            return res?.data

        } catch (e) {
            //console.log(e)
        }
    }

    // search query method
    let count = 0;
    let tempCount = 0;
    const handleSearchQueryChange = (e) => {
        count = count + 1;
        setTimeout(() => {
            if (tempCount + 1 === count) {
                setSearchQuery(e.target.value);
            }
            tempCount = tempCount + 1;

        }, 1000);
    }

    const {
        isLoading,
        data: registerList,
        error
    } = useQuery(['register_List', currentPage, confirmCount, searchQuery], getRegisterList);
    // if (isLoading) return <Loading/>
    // if (error) return <>An error accrued : {error.message}</>


    const loadData = (registerList) => {
        // parse json response
        let responseData = registerList?.data;
        console.log(responseData)
        pagination = {
            page: responseData?.current_page,
            defaultPage: 1,
            perPage: responseData?.per_page,
            count: responseData?.last_page,
            from: responseData?.from,
            to: responseData?.to,
            total: responseData?.total,
            links: responseData?.links
        };

        const jsonData = registerList?.data?.data;
        jsonData?.map(item =>
            rowsData.push({
                id: item?.id,
                title: item?.fullname,
                company_name: enToFaNum(item?.mobile),
                created_at: enToFaNum(item?.created_at),
                started_at: item?.email,

            })
        );
    }

    if (!isLoading && !error) loadData(registerList);

    return (
        <Grid container>
            {/*Content Header*/}
            <Typography variant="h6" component="h2"
                        sx={{fontWeight: '600', lineHeight: "38px", margin: "auto", mt: 3}}>
                ثبت نام کنندگان
            </Typography>

            <Divider sx={{
                width: '100%',
                mb: 4,
                mt: 2,
                height: '2px',
                backgroundColor: 'rgb(89, 46, 169)',
                boxShadow: ' -2px 2px 6px -1px rgb(89, 46, 169)',
            }}/>

            <Search placeholder={"نام فرستنده را جستجو کنید"}
                    onChange={(e) => handleSearchQueryChange(e)} defaultValue={searchQuery}/>
            {/*Content Table Rows*/}
            {isLoading && <Loading/>}
            {error && <div>An error accrued : {error.message}</div>}
            {!isLoading &&
                <Grid item xs={12}>
                    <Grid item xs={12}>
                        <ITable
                            haveAnimation
                            notActiveColor={'#f00'}
                            rows={rowsData}
                            titleHeaders={
                                [
                                    "نام و نام خانوادگی",
                                    "شماره همراه",
                                    "تاریخ",
                                    "ایمیل",
                                ]
                            }
                        />
                    </Grid>
                    {/*Content Pagination*/}
                    <Grid item mt={8} xs={12} display={"flex"} alignItems={"center"} justifyContent={"center"}>
                        <Stack>
                            <Pagination onChange={(event, page) => setCurrentPage(page)}
                                        page={pagination.page}
                                        defaultPage={pagination.defaultPage}
                                        count={pagination.count}
                                        hideNextButton={pagination?.next_page_url === null}
                                        hidePrevButton={pagination?.prev_page_url === null}
                                        variant="outlined"
                                        shape="circular"/>
                        </Stack>
                    </Grid>
                </Grid>
            }
        </Grid>
    );
};

export default DashboardRegistrants;